import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-representative-table-checkbox',
    templateUrl: './representative-table-checkbox.component.html',
    styleUrls: ['./representative-table-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepresentativeTableCheckboxComponent {
  @Input() dataContext: boolean;
}
